export const SITE_URL = "https://skinagent.co";

export const wikiLink = (title: string) => `/wiki/${encodeURIComponent(title)}`;
export const wikiGroupLink = (title: string) => `/wiki/g/${encodeURIComponent(title)}`;
export const wikiEvidenceLink = (title: string) => `/wiki/evidence/${encodeURIComponent(title)}`;
export const wikiExploreLink = (axis: string, value: string) =>
  `/wiki/explore?${axis}=${encodeURIComponent(value)}`;
export const ogImageLink = (title: string, nature?: string) =>
  nature
    ? `/api/og?title=${encodeURIComponent(title)}&nature=${nature}`
    : `/api/og?title=${encodeURIComponent(title)}`;
export const absoluteUrl = (path: string) => `${SITE_URL}${path}`;
export const chatQueryLink = (q: string) => `/chat?q=${encodeURIComponent(q)}`;
export const authRedirectLink = (kind: "signin" | "signup", redirect: string) =>
  `/${kind}?redirect=${encodeURIComponent(redirect)}`;
